/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1655
 */

require(/* 86 */"./1650/86/index")({
  target: "Number",
  stat: true
}, {
  MAX_SAFE_INTEGER: 9007199254740991
})
